var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('span',_vm._g({attrs:{"lang":_vm.$i18n.locale}},on),[_vm._t("default")],2)]}}],null,true)},[_c('span',{attrs:{"lang":_vm.$i18n.locale}},[_vm._v(_vm._s(_vm.tip))])])
}
var staticRenderFns = []

export { render, staticRenderFns }